export default {
  partCards: {
    partHeatNote:
      '熱源は部品自体に適用され、ラップで追加された材料は除外されます。',
    missingContact: '接触が作成されていません',
    cadVolume: 'CAD体積',
    meshVolume: 'メッシュ体積',
    centre: 'CAD中心',
    unmeasured: '未計測',
    perfect: '完全接触',
    gap: '最大CAD隙間',
    perfectBanner:
      '部品間は完全な熱接触として計算されます。接触熱抵抗はモデル化されません。',
    volumeWarning:
      'メッシュ体積とCAD体積が10%以上異なります。W/m³の熱源を確認してください。部品の発熱量は総ワット数で指定できます。',
  },
  meshSweeps: {
    title: 'メッシュスイープ',
    gciLabel: 'グリッド収束指標',
    comingSoon: '近日公開',
    gciDescription:
      '現在の最大サイズを基準に要素サイズをスイープし、{{levels}} 個のグリッドで {{ratio}}× にスケールして離散化誤差を推定します。',
    advanced: '詳細設定',
    refinementRatio: '細分化比',
    levels: 'レベル数',
  },
  fea: {
    material: '材料',
    defaultMaterial: '既定の材料',
    defaultMaterialHint:
      '個別指定がないすべての物体の材料として送信されます。下のアセンブリ割り当ては対象ボリュームを上書きします。',
    modes: 'モード数',
    numberOfModes: 'モード数',
    numberOfModesHint: '1～50 の正の整数。',
    bucklingHint:
      '係数はこの荷重パターンに掛かります。線形座屈は楽観的な上限であり、崩壊荷重の予測ではありません。',
    condition: '状態',
    density: '密度',
    elasticModulus: 'ヤング率',
    poissonsRatio: 'ポアソン比',
    yieldStrength: '降伏強度',
    tensileStrength: '引張強度',
    sweepAxes: 'DOE スイープ軸',
    sweepAxesHint:
      '行に複数の値を入れるとその入力が設計点ごとに変わります。上の荷重・接触の数値は基準のまま残り、ここで広げた行だけが設計点ごとに変わります。',
    seedSweeping:
      'この成分はスイープ中です — DOE スイープ軸でリストを編集してください。',
    materials: {
      steel_304: 'ステンレス鋼 304',
      carbon_steel_1045: '炭素鋼 1045',
      steel_structural: '構造用鋼',
      aluminum_6061: 'アルミニウム合金 6061',
      aluminum_7075: 'アルミニウム合金 7075',
      titanium_ti6al4v: 'チタン合金 Ti-6Al-4V',
      copper_c110: '銅 C110',
      brass_c360: '真鍮 C360',
      inconel_718: 'Inconel 718',
      pcabs: 'PC/ABS',
      polycarbonate: 'ポリカーボネート',
      abs: 'ABS',
      nylon_66: 'ナイロン 66',
      peek: 'PEEK',
      ptfe: 'PTFE',
      hdpe: 'HDPE',
      aluminum_nitride: '窒化アルミニウム',
      diamond_cvd: 'ダイヤモンド (CVD)',
      still_air: '静止空気',
      silicon: 'シリコン',
      silicon_dioxide: '二酸化ケイ素',
      alumina: 'アルミナ',
      silicone: 'シリコーン',
      acrylic: 'アクリル',
      aluminum_5052: 'アルミニウム合金 5052',
      tungsten: 'タングステン',
    },
    // English scientific / expanded names for abbreviations — kept in English
    // so the canonical vocab is discoverable regardless of active locale.
    // Structural materials now source this from
    // `StructuralProperties.description` (structuralMaterials.gen.ts)
    // instead — see material-labels.ts. Only the THERMAL_MATERIAL_LIBRARY
    // entries remain here; they were out of scope for that migration.
    materialsFull: {
      aluminum_nitride: 'Thermal-management ceramic',
      diamond_cvd: 'Synthetic diamond heat spreader',
      // silicon / silicon_dioxide / silicone / aluminum_5052 / tungsten:
      // omit — display names are already plain English.
      alumina: 'Aluminum oxide ceramic',
      acrylic: 'Polymethyl methacrylate (PMMA)',
    },
  },
  feaTemplate: {
    structural: '構造',
    modal: 'モーダル',
    buckling: '座屈',
    thermal: '熱伝導',
    thermalRegime: '熱解析の種類',
    thermalSteady: '定常',
    thermalTransient: '非定常',
  },
  thermal: {
    defaultMaterial: '固体材料',
    materialsByVolume: 'ボリューム別材料',
    defaultMaterialHint:
      '全ボリュームの既定固体材料です。メッシュに Volume_* がある場合、下のボリューム別ピッカーが上書きします。',
    defaultConvectionH: '既定の熱伝達係数',
    defaultConvectionHHint:
      '面を対流に設定したときに使う周囲の熱伝達係数 h。固体材料の物性ではありません — 自然対流空気 ~5–25、強制対流空気 ~50–250、水 ~1000+ W/(m²·K)。',
    syncConvectionH: 'h を対流面 {{count}} 枚に適用',
    syncConvectionHEmpty: '更新する対流面がまだありません。',
    syncConvectionHTooltip:
      'すべての対流面の熱伝達係数を {{h}} W/(m²·K) に設定します。',
    initialTemperature: '初期温度',
    initialTemperatureHint:
      '解析開始時の固体の一様温度。すべての固体体積のすべての節点 (Nall) に適用されます。面の境界条件ではありません — 面荷重と対流は BC 行にあります。',
    initialTemperatureVolumes:
      '{{volumes}} のすべての節点に一様に適用。面の境界条件ではありません — 面荷重と対流は上の BC 行にあります。',
    initialTemperatureAllVolumes:
      'すべての固体体積のすべての節点 (Nall) に一様に適用。面の境界条件ではありません — 面荷重と対流は上の BC 行にあります。',
    solverTitle: '定常熱伝導',
    solverBody:
      'ソルバーは温度場が落ち着くまで反復します。Overview は残差チェックと境界フラックス積分の熱収支で converged を評価します — Draft では残差目標値は編集できません。',
    transientSolverTitle: '非定常熱伝導',
    transientSolverBody:
      'ソルバーは物理時間を進めます。Overview は期間ゲート、エネルギー収支 (J)、最大原理の温度境界チェックで converged を評価します — Draft では残差目標値は編集できません。',
  },
  feaSolveLoop: {
    helpLabel: 'ステップ・増分・反復の入れ子',
    step: 'ステップ',
    increment: '増分',
    iteration: '反復',
    stepRan: 'ステップ · {{count}} 実行',
    stepRequested: 'ステップ · {{count}} 要求',
    incrementRan: '増分 · {{count}} 実行',
    incrementRequested: '増分 · {{count}} 要求',
    iterationRan: '反復 · 最大 {{count}}',
    iterationRequested: '反復 · 最大 {{count}} 要求',
    stepHelp: '期間全体を覆う 1 つの解析手順です。',
    incrementHelp: 'ステップ内で物理時間を 1 回進める単位です（下の Δt 欄）。',
    iterationHelp: '増分内で残差が落ち着くまで行う Newton 平衡反復です。',
  },
  transientTime: {
    title: '時間スケジュール',
    hint: '熱伝達ステップの長さと時間の進め方。任意項目を空欄にすると自動既定値が使われます。',
    period: 'サイクル期間 (s)',
    periodHint:
      'この熱伝達ステップの全物理時間。ソルバーがこの期間に到達して初めて完了とみなされます。',
    initialIncrement: '初期増分 (s)',
    initialIncrementHint:
      '最初の時間ステップの大きさ。空欄ならサイクル期間の 1/100。急な境界変化で細かいメッシュがアンダーシュートする場合は大きめにします。',
    minIncrement: '最小増分 (s)',
    minIncrementHint:
      'カットバック時に許される最小時間ステップ。空欄なら自動下限です。',
    maxIncrement: '最大増分 (s)',
    maxIncrementHint: '増分を伸ばすときの上限。空欄ならサイクル期間の 1/10。',
    outputInterval: '出力間隔 (s)',
    outputIntervalHint:
      '結果タイムライン用の温度フレームを書き出す間隔。空欄なら初期増分に合わせます（約 101 フレーム、最大約 200）。',
    maxTemperatureChange: 'ステップあたり最大 ΔT (K)',
    maxTemperatureChangeHint:
      '1 増分で許される最大温度変化。いずれかの節点がこれを超えるとソルバーはステップを切り詰めます。空欄なら増分上下限のみが支配します。',
    fixedIncrements: '固定増分',
    fixedIncrementsHint:
      '時間ステップサイズを固定します（自動カットバックなし）。既定はオフで、残差が停滞したときにソルバーがステップを縮小できます。',
    maxIncrements: '最大増分数',
    maxIncrementsHint:
      'この熱伝達ステップの時間ステップ数の上限。既定値は 1000。',
    autoPlaceholder: '自動',
  },
  feaAdvancedSummary:
    '保存済みの構造ソルバー入力です。材料、境界条件、接触、予荷重は「物理と境界条件」で編集します。',
  forceVector: {
    cannotBeZero: '力ベクトルをゼロにはできません',
  },
  direction: {
    label: '方向',
    auto: '自動 — 流れ軸（{{axis}}）',
    studyDefault: 'スタディの既定値',
    custom: 'カスタム（x, y, z）',
    cannotBeZero: '方向ベクトルをゼロにはできません',
    normalizedNote: '実行時に単位ベクトルへ正規化されます。',
    tooltip:
      '流入方向。スタディ内すべての実行に共通して適用されます — 速度スイープは速さのみを変化させ、方向は固定です。オプション：自動 (Auto) は検出された流れ軸に追従、±X/±Y/±Z は軸にスナップ、カスタム (Custom) は (x, y, z) ベクトルを入力（実行時に正規化）。',
  },
  rasWarnings: {
    wallResolvingLead: 'k-ω SST は壁面解像モデルです',
    wallResolvingBodyPre:
      '選択したメッシュに境界層がありません。正確な結果を得るには、MeshGen で境界層のターゲットを次の値に設定してメッシュを再生成してください：',
    wallResolvingBodyPost:
      'ソルバーは実行されますが、壁近傍の物理は正しくなりません。',
    wallFunctionsLead: '{{model}} は壁関数を使用します',
    wallFunctionsBodyPre: '理想値',
    wallFunctionsBodyPost:
      '選択したメッシュに境界層がなく、結果が不正確になる可能性があります。壁関数向けの境界層で再生成することを検討してください。',
    lengthScaleLead: '乱流長さスケール (turbulent length scale) が未設定です',
    lengthScaleBodyPre: 'バックエンドは次の値にフォールバックします：',
    lengthScaleBodyPost:
      'これはほとんどの CAD パーツには大きすぎます。より正確な初期 ω / ε を得るには、物体の特徴長さ（コード長、直径、スパン）の約 7〜10% に設定してください。',
  },
  advanced: {
    title: '詳細設定',
    convergenceCriteria: '収束条件',
    solverSettings: 'ソルバー設定',
    forceCoeffsTitlePrefix: '力係数',
    refArea: '参照面積（m²）',
    refChord: '参照コード長（m）',
    egValue: '例：{{value}}',
    forceCoeffsHintPrefix: '空欄でスキップ',
    forceCoeffsHintSuffix: 'を結果から除外します',
    refAreaInfo:
      '空気力を C_D / C_L に正規化するための投影正面積。翼型ではコード長 × スパン、鈍頭物体では流れに対向する面積。単位：m²。',
    refChordInfo:
      'ピッチングモーメントを C_M に正規化するための代表長 — 通常は翼型のコード長。単位：m。',
    presetsLabel: 'プリセット',
    presetFluent: 'Fluent / STAR-CCM+ 既定に合わせる',
    presetLowRe: '低レイノルズ数 / 粘性副層 (Low-Re)',
  },
  // OpenFOAM SIMPLE アルゴリズム上書きのラベルとツールチップ. panel.md
  // 規約に従い「これは何か」+「いつ調整するか」を自然言語で説明する.
  // OpenFOAM の内部辞書キー名は削除. 工学領域の用語 (SIMPLE, laminar,
  // RAS, snappyHexMesh, hex/tet, upwind, SST) はユーザーが知っている
  // モデル語彙として残す.
  openFoamOverrides: {
    booleans: {
      on: '有効 (On)',
      off: '無効 (Off)',
    },
    endTime: {
      label: '最大反復回数',
      description:
        'ソルバー反復のハードキャップ。この上限か下の残差目標のどちらかが先に達した時点で実行を停止します。デフォルト：1000 (層流) / 2000 (RAS)。',
    },
    maxRunTime: {
      label: '時間制限 (時間)',
      description:
        '1回の実行にかけられる最長時間（時間単位）。時間になるとソルバーは正常に停止して進捗を保存するため、あとで実行を続行できます。デフォルト：4時間、最大11時間。',
      outOfRange: '時間制限は1分から11時間の間で指定してください。',
    },
    residualControlP: {
      label: '圧力残差',
      description:
        '圧力残差がどこまで下がれば収束とみなすか。低いほど収束が厳密, 実行時間が長くなる。デフォルト：1e-4。',
    },
    residualControlU: {
      label: '速度残差',
      description:
        '速度残差がどこまで下がれば収束とみなすか。速度は圧力より収束しにくい — 理由がなければ ~1e-4 以上に保つ。デフォルト：5e-3。',
    },
    writeInterval: {
      label: '書き出し間隔',
      description:
        'ソルバーが結果スナップショットをディスクに書き出す頻度 (反復回数)。値が小さいほど残差プロットが細かく、その分ディスク使用量が増える。デフォルト：50。',
    },
    nNonOrthCorrectors: {
      label: '非直交補正回数',
      description:
        '各反復で歪みセルを補正するための追加圧力補正回数。歪みの強い四面体メッシュでは 3~4 に増やす; 六面体主体のメッシュでは 2 のまま。デフォルト：2。',
    },
    relaxP: {
      label: '圧力緩和係数',
      description:
        '圧力の緩和 — 各反復で新たに計算された圧力をどれだけ混ぜるか。低いほど安定するが収束が遅い。デフォルト：0.3 (層流) / 0.2 (RAS)。',
    },
    relaxU: {
      label: '速度緩和係数',
      description:
        '速度の緩和。低いほど安定するが収束が遅い; 0.5 は多くのケースで両者のバランスを取る。デフォルト：0.5。',
    },
    relaxTurbulence: {
      label: '乱流緩和係数',
      description:
        '乱流場 (k とその散逸) の緩和。低いほど安定するが遅い; 乱流値が不安定なら 0.3 まで下げる。RAS のみ — 層流では効果なし。デフォルト：0.5。',
    },
    gradScheme: {
      label: '勾配スキーム',
      description:
        'ソルバーがセル間の勾配をどう近似するか。「Unlimited」はほぼ直交な六面体メッシュで最速かつ高精度; cell-limited 系は歪み四面体メッシュで勾配を抑制して発振を防ぐ。デフォルト：unlimited。',
      options: {
        unlimited: '無制限 (Unlimited)',
        cell_limited_half: 'セル制限 (半分)',
        cell_limited_full: 'セル制限 (完全)',
      },
    },
    divScheme: {
      label: '対流スキーム',
      description:
        'ソルバーが運動量対流をどう離散化するか。「Linear upwind」は 2 次かつ安定 — デフォルト。「Upwind」は 1 次で境界的なメッシュ向け; 「limited linear」は衝撃・急勾配ケース向け。デフォルト：linear upwind。',
      options: {
        upwind: '風上 1 次 (Upwind)',
        linear_upwind: '線形風上 2 次 (Linear upwind)',
        limited_linear: '制限付き線形 (Limited linear)',
        linear: '線形中心差分 (Linear)',
      },
    },
    linearSolvers: {
      label: '線形ソルバー',
      description:
        '各フィールドの線形ソルバー上書き. 上級者向け設定; 現時点でこのパネルからは編集不可.',
    },
    divSchemeTurbulence: {
      label: '発散スキーム，乱流 (div scheme, turbulence)',
      description:
        'k / ω / ε の対流スキーム. 「Upwind」は 1 次精度で安定 — 既定. 2 次精度の選択肢は Fluent / STAR-CCM+ の既定と一致.',
    },
    pInterpolation: {
      label: '圧力補間 (p interpolation)',
      description:
        'セル面上での圧力補間. 空欄で既定の線形 (linear) を使用; midPoint / cubic は他ソルバーとのスキーム比較用.',
      options: {
        linear: '線形 (Linear)',
        midPoint: '中点 (Midpoint)',
        cubic: '立方 (Cubic)',
      },
    },
    nutWallFunction: {
      label: 'ν_t 壁関数 (nut wall function)',
      description:
        '乱流粘性の壁関数. 既定は対数則領域. Spalding は緩衝領域をブレンド, LowRe は粘性副層をメッシュ側で解像.',
      options: {
        nutkWallFunction: '対数則 (nutkWallFunction)',
        nutUSpaldingWallFunction: 'ブレンド (nutUSpaldingWallFunction)',
        nutLowReWallFunction: '粘性副層 (nutLowReWallFunction)',
      },
    },
    kWallFunction: {
      label: 'k 壁関数 (k wall function)',
      description:
        '乱流エネルギの壁関数. 既定は対数則+緩衝で安定; LowRe は壁近傍解像メッシュ用.',
      options: {
        kqRWallFunction: '既定 (kqRWallFunction)',
        kLowReWallFunction: '粘性副層 (kLowReWallFunction)',
        fixedValue: 'BC 指定 (fixedValue)',
      },
    },
    omegaWallFunction: {
      label: 'ω 壁関数 (omega wall function)',
      description:
        '比散逸の壁関数. 既定は全 y+ ブレンド; `fixedValue` は BC 指定比較用.',
      options: {
        omegaWallFunction: '全 y+ (omegaWallFunction)',
        fixedValue: 'BC 指定 (fixedValue)',
      },
    },
    epsilonWallFunction: {
      label: 'ε 壁関数 (epsilon wall function)',
      description:
        '散逸率の壁関数. k-ε モデル用; LowRe は粘性副層解像メッシュ用.',
      options: {
        epsilonWallFunction: '対数則 (epsilonWallFunction)',
        epsilonLowReWallFunction: '粘性副層 (epsilonLowReWallFunction)',
      },
    },
    residualControlTurbulence: {
      label: '残差，乱流 (residual, turbulence)',
      description: '乱流残差 (k + ω または ε) の収束判定しきい値. 既定: 1e-4.',
    },
    laplacianLimiter: {
      label: 'ラプラシアンリミッター (Laplacian limiter)',
      description:
        '面勾配補正の強さを制御. 1.0 で完全陽的補正 (Fluent / STAR-CCM+ 相当); 既定 0.33 は歪みメッシュでも安定.',
    },
    simpleConsistent: {
      label: 'SIMPLE 一致性補正 (SIMPLE consistent)',
      description:
        'SIMPLE アルゴリズムの一致性補正を有効化 (既定 ON). OFF にすると Fluent / STAR-CCM+ の既定に合う. 外部流のみ.',
    },
    prefCell: {
      label: '基準圧力セル (pRef cell)',
      description:
        '閉じた計算領域で圧力基準を固定するセルの索引. 特別な指定がなければ 0.',
    },
    prefValue: {
      label: '基準圧力値 (pRef value)',
      description:
        '基準セルで固定する圧力値. 非圧縮では運動学的圧力 (m²/s²); ゲージ基準を設定しない限り 0.',
    },
    writeFormat: {
      label: '出力形式 (write format)',
      description:
        '結果ファイルの出力形式. Binary は数百万セル規模でタイムステップディレクトリを約 10 倍小さくできる.',
      options: {
        ascii: 'ASCII（既定, 可読）',
        binary: 'Binary（コンパクト）',
      },
    },
    writePrecision: {
      label: '出力精度 (write precision)',
      description:
        '結果ファイルに出力する有効桁数. 他ソルバーとの Cd/Cl 比較では 15 に上げる. 既定: 6.',
    },
    writeCompression: {
      label: '出力圧縮 (write compression)',
      description:
        '結果ファイルの zlib 圧縮. 長時間 RAS でディスクが逼迫する場合に有効.',
    },
  },
  // 勾配スキーム + 線形ソルバーのオーバーライドプレビュー. 既定は OFF
  // (VITE_SIMOPS_SOLVER_SCHEMES) — バックエンドは現状これらをハードコードして
  // いるため, BE 契約が入るまでは送信しないプレビュー.
  schemesOverride: {
    title: '離散化と線形ソルバー',
    previewBanner:
      'プレビュー — バックエンドはまだ受け付けません. 値は保存・送信されません. ソルバースキーム契約が入り次第有効化できます.',
    gradientGroup: '勾配制御',
    linearSolverGroup: '線形ソルバー',
    gradLimited: {
      label: '勾配を制限',
      description:
        'セル間の勾配を抑制するスキームを使用 (無制限スキームの代わり). 精度をわずかに犠牲にして歪んだセルでの堅牢性を得る — tet または poly メッシュで推奨.',
    },
    gradLimiterCoeff: {
      label: 'リミッター係数',
      description:
        '勾配抑制の強さ: 0 = 制限なし, 1 = 完全制限. 「勾配を制限」が有効なときのみ使用.',
    },
    pSolver: {
      label: '圧力ソルバー',
      placeholder: 'GAMG (既定)',
      description:
        '圧力方程式の線形ソルバー. GAMG (幾何・代数マルチグリッド) が既定で多くのケースで最速; PCG と PBiCGStab は Krylov 系の代替.',
    },
    pTolerance: { label: 'p 許容誤差' },
    pRelTol: { label: 'p relTol' },
    uTolerance: { label: 'U 許容誤差' },
    uRelTol: { label: 'U relTol' },
    errors: {
      limiterCoeffRange: 'リミッター係数は 0 から 1 の間である必要があります.',
      tolerancePositive: '許容誤差は 0 より大きい必要があります.',
      relTolRange: '相対許容誤差は 0 から 1 の間である必要があります.',
    },
  },
  simTypeFromMesh: {
    fromMesh: 'MeshGen で設定済み',
    internal: '内部流れ',
    external: '外部流れ',
    tooltip:
      '選択したメッシュは MeshGen でこのシミュレーションタイプ用に作成されているため、スタディは自動的にそれに従います。別のタイプを実行するには、MeshGen で新しいメッシュを作成してください。',
    mixed:
      '選択したメッシュのシミュレーションタイプが一致していません。実行するタイプを選択するか、一致しないメッシュを外してください。',
  },
  simType: {
    cfd: {
      title: '数値流体力学。',
      summary: 'k-ω SST で定常非圧縮性流れ（速度・圧力・乱流）を解きます。',
      mesh: 'メッシュ：単一領域の流体メッシュ（四面体または六面体）。壁面の境界層インフレーション — 解像壁は y⁺ ≲ 1、壁関数使用時は y⁺ ≈ 30〜300。流入 / 流出 / 壁のパッチは MeshGen でタグ付けします。',
    },
    fea: {
      title: '有限要素解析。',
      summary: '固体力学 — 静的荷重下の応力・ひずみ・変形。',
      mesh: 'メッシュ：固体のみの四面体または六面体で、接触 / 荷重支持面および応力集中部を細分化します。',
    },
    cht: {
      title: '共役熱伝達。',
      summary:
        '流体の流れと固体の熱伝導を連成 — 領域ごとの温度とピークホットスポット温度を報告します。',
      mesh: 'メッシュ：1 つの流体領域と 1 つ以上の固体を含む多領域四面体メッシュ。各領域は個別にメッシュ化・求解され、熱は流体-固体界面を横断して伝わります。タグ付けされた面が流入・流出・固定温度・熱流束・対流の境界条件を駆動します。',
    },
  },
  form: {
    inletSweep: '流入スイープ',
    outletSweep: '流出スイープ',
    velocity: '速度',
    velocityNote:
      '選択した方向に沿った速度。カンマでスイープになります — 値ごとに 1 回実行（1, 2, 3 → 3 回実行）で、3D ベクトルではありません。',
    pressure: '圧力',
    pressureNote: 'ゲージ圧 — 0 = 環境基準（絶対圧 1 atm）',
    sweepFieldInfoAria: 'スイープ欄がデザインポイントを生成する仕組み',
    sweepFieldInfo:
      'この欄がデザインポイントになる仕組み:\n\n• 単一値 → その値で 1 回実行.\n• カンマ区切りのリスト → 各値 1 回ずつ実行.\n• 複数のスイープ欄 → 全組み合わせを実行 (2 × 3 → 6 回).\n\n現在 CFD でスイープ可能: 入口速度・出口圧力, および 密度 ρ / 動粘度 μ / 運動粘度 ν のうち 2 つ (残り 1 つは ν = μ/ρ で導出).\n\nこれらの欄の値がスタディの既定値. すべての DP はこの値を使用し, 明示的に上書きした場合のみ異なる値になる. したがってここで欄を編集するとスイープ全体の既定値が変わる — 別途「既定として保存」操作は不要.\n\n手動 DP はスイープの後ろに追加される個別の点. 直積を増やさず (1 個 = 追加実行 1 回), 手動 DP で空欄のままの欄はここの既定値を継承する.',
    flowType: '流れの種類',
    // 乱流モデルのドロップダウン。工学用語 (k-ε / k-ω / SST) は文献検索の
    // ために英語をそのまま残し、自然言語の名詞を添える。
    flowTypeOptions: {
      laminar: '層流 (Laminar)',
      k_epsilon: '乱流 k-ε (k-epsilon)',
      k_omega: '乱流 k-ω (k-omega)',
      k_omega_sst: '乱流 k-ω SST',
    },
    flowTypeShort: {
      laminar: '層流',
      k_epsilon: 'k-ε',
      k_omega: 'k-ω',
      k_omega_sst: 'k-ω SST',
    },
    turbulence: '乱流',
    intensity: '強度',
    intensityTooltip:
      '速度変動と平均流れの比（u′/U）。初期乱流運動エネルギー k を設定します。典型値：外部流 0.01〜0.05、内部流 0.05〜0.10。',
    lengthScale: '長さスケール（m）',
    lengthScaleTooltip:
      '初期 ω と ε を設定するための特徴渦サイズ。目安：ジオメトリの特徴長さ（コード長、直径）の約 7%。既定値は 0.1 m。',
    flowTypeDefaults: '{{label}} の既定値',
    clickToView: '· クリックで表示',
    flowTypeDefaultsCard: {
      notes: {
        laminar:
          '乱流モデルなし。Re ≲ 2,000 の内部流や低 Re の外部流に適します。',
        k_epsilon:
          '標準 k-ε モデル。自由流では堅牢ですが、壁関数なしでは壁近傍の精度が低下します。y+ が対数則の範囲 (30~300) にある場合のみ使用してください。',
        k_omega:
          'Wilcox k-ω モデル。k-ε より壁近傍の挙動が良好ですが、自由流の ω 境界値に敏感です。ほとんどの外部空力ケースでは SST を選択してください。',
        k_omega_sst:
          'Menter k-ω SST モデル。境界層では k-ω、自由流では k-ε をブレンドします — ほとんどの外部空力および内部流 CFD の安全な既定値。壁面まで解像 (y+ ≲ 1) または壁関数 (y+ ≳ 30) を使用します。',
      },
      labels: {
        maxIterations: '最大反復回数',
        residualPU: '残差 p / U',
        writeInterval: '書き込み間隔',
        nonOrthCorrectors: '非直交補正回数',
        relaxPU: '緩和 p / U',
        turbulenceIntensity: '乱流強度',
        lengthScale: '長さスケール',
      },
      values: {
        lengthScaleHint: 'ユーザー設定 (物体長の ≈ 7 %)',
      },
    },
  },
  unsupported: {
    title: '{{template}} はまだ UI で編集できません。',
    body: 'このテンプレートを使用する研究は、API または以前のバージョンのフロントエンドで作成されました。保存された設定はレポートで確認できます。編集するには、上部のトグルで研究の種類を切り替えてください。',
  },
  fluidProps: {
    fluid: '流体',
    density: '密度',
    dynamicViscosity: '粘度',
    kinematicViscosity: '動粘度',
    derivedFrom: '{{a}} と {{b}} から導出',
    pinDerivedTip:
      '{{field}} は導出値です。別のフィールドのリンクアイコンをクリックすると、そちらを導出値にできます。',
    pinUserDefinedTip:
      '{{field}} はユーザー定義です。クリックすると導出フィールドに設定できます。',
    presets: {
      air: '空気 (20 °C)',
      water: '水 (20 °C)',
      custom: 'カスタム',
    },
  },
  sweepField: {
    // Accessible names for the two comboboxes inside a sweep field whose
    // only content is their own current value (ENG-1733). `unitAria` is the
    // fallback for a field whose label is a ReactNode with no string form.
    unitForAria: '{{field}} の単位',
    unitAria: '単位',
    priorForAria: '{{field}} の事前分布',
    modeToggleAria: 'スイープモード',
    single: '単一',
    range: '範囲',
    lowerBound: '下限',
    upperBound: '上限',
    prior: '事前分布',
    priorUniform: '一様',
    priorLogUniform: '対数一様',
    sweepCount: '{{count}} 個の値 · スイープ（各値につき 1 回実行）',
    continuous: '連続、研究のサンプリングから抽出',
  },
  // スイープ軸のパス — プレビュー列ヘッダー・上書きチップ・チャート凡例
  // で使用. 生のパス (`inlet.velocity` など) はスキーマ用語なので, 平易な
  // 名前に置き換える.
  sweepPaths: {
    inletVelocity: '入口速度',
    outletPressure: '出口圧力',
    // ギリシャ文字は表記に慣れた読者向けに残し, 先頭の名詞で初見の読者にも
    // 意味が通るようにする.
    rho: '密度 (ρ)',
    mu: '動粘度 (μ)',
    nu: '運動粘度 (ν)',
    initialTemperature: '初期温度',
    axisFx: 'Fx',
    axisFy: 'Fy',
    axisFz: 'Fz',
    loadVector: '{{target}} · {{axis}}',
    facePressure: '{{target}} · 圧力',
    contactFriction: '接触 {{name}} · 摩擦',
    contactStiffness: '接触 {{name}} · 剛性',
    contactStickSlope: '接触 {{name}} · スティックスロープ',
    boltPreload: 'ボルト {{name}} · 予圧',
    tieTolerance: '結合 {{name}} · 位置公差',
    thermalValue: '{{target}} · 温度 / 熱流束',
    convectionH: '{{target}} · 対流 h',
    ambientTemperature: '{{target}} · 外気温度',
    radiationEmissivity: '{{target}} · 放射率',
    gravityMagnitude: '重力 · 大きさ',
    centrifugalRpm: '遠心力 · RPM',
  },
  responseKeys: {
    nu: '動粘度 (ν)',
    rho: '密度 (ρ)',
    outletVelocity: '出口速度',
    pumpingPower: 'ポンプ動力',
    thermalResistance: '熱抵抗',
    pressureDrop: '圧力損失',
    inletFlowRate: '流入流量',
    outletFlowRate: '流出流量',
    // 作用力 — CFD の表面積分により得られる分量成分. 方向は X/Y/Z で
    // 明示; F_x 下付き記法は論文寄りで、UI ラベルには平文で十分.
    forceX: '作用力 X',
    forceY: '作用力 Y',
    forceZ: '作用力 Z',
    hottestSolid: '最高固体温度',
    targetMet: '目標達成',
    targetTemperature: '目標温度',
    // Kinematic pressure = p/ρ (m²/s²). 「動圧」は ½ρU² を指すので誤訳.
    pressureDropKinematic: '運動学的圧力損失',
    lastTimeStep: '最終タイムステップ',
    timeSteps: 'タイムステップ数',
    // OpenFOAM の ExecutionTime — ソルバー内で計測される 1 反復あたりの
    // 実時間. 単に「実行時間」だと OS プロセス時間と紛らわしいので
    // 「ソルバー実行時間」で明示.
    executionTime: 'ソルバー実行時間',
    iterations: '反復回数',
    // 「計算収束」— 数値的な収束であることを明示. 単なる「収束」は
    // 「引き締まる / まとまる」と紛らわしい.
    converged: '計算収束',
    // 「求解発散」— 「発散」は物理では diffuse とも読み得るため、
    // 「ソルバー発散」と限定してディフュージョン (拡散) と区別.
    divergenceDetected: 'ソルバー発散を検出',
    hasHeatSource: '発熱源あり',
    totalHeatFlux: '総熱流束',
    peakHeatFlux: '最大熱流束',
    interface: '界面',
    volume: '体積',
    area: '面積',
    // ENG-1952 パッチ別界面の内訳。濡れ面積、壁温度、膜係数が割る壁→バルク ΔT。
    // 領域ごとの材料物性。導電率ではなく熱伝導率、電力ではなく発熱量。
    // ワイヤ名 (`conductivity_w_m_k`, `declared_power_w`) はどちらとも
    // 読めるため、ラベル側で明示する。
    thermalConductivity: '熱伝導率',
    specificHeat: '比熱',
    declaredHeatLoad: '宣言熱源出力',
    volumeAveragedTemp: '体積平均温度',
    initialTemp: '初期温度',
    perPatchArea: 'パッチ別 面積',
    perPatchWallTemp: 'パッチ別 壁温度',
    perPatchWallBulkDt: 'パッチ別 壁→バルク ΔT',
    bulkTemp: 'バルク温度',
    totalHeatFluxSolidSide: '総熱流束 (固体側)',
    interfaceDisagreement: '界面の不一致',
    // エネルギー収支ブロック: 投入熱と除去熱、およびその差。
    energyBalance: 'エネルギー収支',
    heatInput: '投入熱',
    heatRemoved: '除去熱',
    heatBalanceTolerance: '熱収支許容値',
    // thermal_transient DP ショートリスト列 (ENG-3002 / TH-6)。
    peakTemperature: 'ピーク温度',
    peakTime: 'ピーク時刻',
    peakBody: 'ピーク部位',
    timeReached: '到達時刻',
    nIncrements: '増分回数',
    nFrames: 'フレーム数',
    bodyTemperatures: '体積温度',
    bodyPeakTemperatures: '体積ピーク温度',
    surfaceFluxesW: '表面熱流束',
    temperatureBounds: '温度上下限',
    energyIn: '投入エネルギー',
    energyOut: '除去エネルギー',
    storedEnergyChange: '蓄積エネルギー変化',
    energyImbalance: 'エネルギー不均衡',
    imbalance: '不均衡',
    imbalancePct: '不均衡',
    verdict: '判定',
    perPatch: 'パッチ別',
    solidPerPatch: 'パッチ別 (固体側)',
    peakFluxPatch: 'ピーク熱通量パッチ',
    hottestSolidRegion: '最高温固体',
    convergence: '収束性',
    finalResiduals: '最終残差',
    fluid: '流体',
    solid: '固体',
    limiterClamps: 'リミッタークランプ',
    velocityCells: '速度セル数',
    velocityCellsPct: '速度セル (%)',
    temperatureLowerCells: '温度セル (下限)',
    temperatureUpperCells: '温度セル (上限)',
    temperatureLowerCellsPct: '温度セル (下限, %)',
    temperatureUpperCellsPct: '温度セル (上限, %)',
    temperatureUnlimitedMaxK: '未クランプ最高温度',
    temperatureUnlimitedMinK: '未クランプ最低温度',
    temperatureUnlimitedMax: '未クランプ最高温度',
    temperatureUnlimitedMin: '未クランプ最低温度',
    coolantDeltaT: '冷媒 ΔT',
    coolantMassFlow: '冷媒質量流量',
    coolantMassImbalance: '冷媒質量不平衡',
    limitTemperatureMax: '温度クランプ上限',
    simError: 'シミュレーションエラー',
    detail: '詳細',
    statMin: '最小',
    statAvg: '平均',
    statMax: '最大',
    // 概念語 (温度/流速) を先頭に置き、方程式記号 T/U を UI では省く.
    // 論文では T_min / U_max と書くが、ラベルは平文で十分.
    tempStat: '温度{{stat}}',
    velMax: '流速最大',
    // 場は括弧で示す (U/p/k/ω/ε/h). R 記号は論文寄りの数式標記なので
    // UI ラベルには省略.
    finalResidual: '最終残差 ({{field}})',
    initialResidual: '初期残差 ({{field}})',
    // FEA (CalculiX 構造静解析) の結果列ラベル. 「von Mises」は応力評価基準の
    // 固有名なので各言語で原文のまま. 単位 (MPa / mm) は列側で付加されるため
    // ここでは量の名称のみ.
    maxVonMises: '最大 von Mises 応力',
    maxVonMisesNode: '最大 von Mises 節点',
    maxPrincipal: '最大主応力',
    maxPrincipalNode: '最大主応力の節点',
    minPrincipal: '最小主応力',
    minPrincipalNode: '最小主応力の節点',
    maxShear: '最大せん断応力',
    materialYield: '材料降伏強度',
    materialUltimate: '材料引張強度',
    maxDisplacement: '最大変位',
    maxDisplacementNode: '最大変位節点',
    safetyFactorYield: '安全率 (降伏)',
    safetyFactorUltimate: '安全率 (引張)',
    // 非数値の FEA スカラー: 合否判定と適用材料.
    assessment: '判定',
    materialName: '材料',
    // external_flow の流れ軸に依存しない壁面荷重分解. 力は圧力 (法線) /
    // 粘性 (接線) トラクションの大きさ; 壁面圧力は物体壁面のゲージ圧極値.
    // 単位 (N / Pa) はヘッダーに付与; 比は無次元.
    forceNormalMag: '法線力',
    forceTangentialMag: '接線力',
    normalTangentialRatio: '法線 / 接線 比',
    wallPressureMin: '壁面圧力 (最小)',
    wallPressureMax: '壁面圧力 (最大)',
    // 軸ごとの壁面トラクション分解 — `_mag` スカラーのベクトル対応.
    // 圧力 = 法線成分 (バースト / フープ駆動);
    // 粘性 = 接線成分 (表面摩擦).
    forcePressureX: '圧力 X',
    forcePressureY: '圧力 Y',
    forcePressureZ: '圧力 Z',
    forceViscousX: '粘性力 X',
    forceViscousY: '粘性力 Y',
    forceViscousZ: '粘性力 Z',
    // 入口平均速度 — 収束時の入口面積加重平均.
    inletVelocityAvg: '入口速度',
    // 「質量不均衡」— |入口 − 出口| / max — 無次元の保存誤差.
    massImbalanceFrac: '質量不均衡',
    // ソルバーが検出した非物理状態 (負体積 / 非有限残差 / 不良 BC).
    solutionUnphysical: '非物理解',
    // 力係数 (external_flow, sim_params.force_coeffs 設定時のみ出力).
    // すべて無次元 — ラベルに単位は付かない.
    cd: '抗力係数 (C_D)',
    cl: '揚力係数 (C_L)',
    cmPitch: 'ピッチングモーメント係数 (C_M)',
    clCdRatio: '揚抗比 (L/D)',
    copFracLref: '圧力中心比 (l_ref)',
    cdBand: 'C_D 安定バンド',
    clBand: 'C_L 安定バンド',
    cdDrift: 'C_D ドリフト',
    clDrift: 'C_L ドリフト',
    // 領域全体の流体温度アグリゲート (CFD + 熱).
    temperatureMin: '温度 (最小)',
    temperatureAvg: '温度 (平均)',
    temperatureMax: '温度 (最大)',
    // 壁面 y⁺ 集約値 (external_flow パーサー). 無次元.
    yplusMin: 'y⁺ 最小',
    yplusMean: 'y⁺ 平均',
    yplusMax: 'y⁺ 最大',
    // 質量・慣性（FEA の質量特性）。単位（kg / kg·m² / m）は
    // responseKeyUnit から列ヘッダーに付与される。
    mass: '質量',
    inertiaIxx: '慣性モーメント Ixx',
    inertiaIyy: '慣性モーメント Iyy',
    inertiaIzz: '慣性モーメント Izz',
    inertiaIxy: '慣性モーメント Ixy',
    inertiaIxz: '慣性モーメント Ixz',
    inertiaIyz: '慣性モーメント Iyz',
    radiusOfGyrationX: '回転半径 X',
    radiusOfGyrationY: '回転半径 Y',
    radiusOfGyrationZ: '回転半径 Z',
    yplusFracBelow5: 'y⁺ 面積比 (< 5)',
    yplusFrac5To30: 'y⁺ 面積比 (5–30)',
    yplusFrac30To100: 'y⁺ 面積比 (30–100)',
    yplusFracAbove100: 'y⁺ 面積比 (> 100)',
    cumulativeContinuity: '累積連続性',
    solverFailed: 'ソルバー失敗',
    velocityRunaway: '速度の発散',
    singularMatrixDetected: '圧力行列が特異',
    hintBcIc: 'ヒント: 境界・初期条件を確認',
    hintMeshQuality: 'ヒント: メッシュ品質を確認',
    hintTurbulence: 'ヒント: 乱流モデルを確認',
    exitCode: '終了コード',
    maxPLinearIters: '圧力ソルバー最大反復数',
    divergenceOnsetStep: '発散開始ステップ',
    firstDivergedField: '最初に発散した場',
    solverMpiRanks: 'ソルバー MPI ランク数',
    totalPressureDropPa: '全圧損失',
    totalPressureDropKinematic: '全圧損失 (動学)',
    zeta0: 'ζ₀ (全圧損失係数)',
    zetaP: 'ζₚ (静圧損失係数)',
    velocity: '速度',
    pressure: '圧力',
    density: '密度',
    temperature: '温度',
    angleOfAttackDeg: '迎え角 α (度)',
    sideslipDeg: '横滑り角 β (度)',
    inlet: '入口',
    outlet: '出口',
  },
  fieldNames: {
    displacement: '変位量',
    displacement_x: 'x 方向変位',
    displacement_y: 'y 方向変位',
    displacement_z: 'z 方向変位',
    von_mises: 'von Mises 応力',
    max_principal: '最大主応力',
    min_principal: '最小主応力',
    max_shear: '最大せん断応力',
    temperature: '温度',
    U: '流速',
    Ux: '流速 x',
    Uy: '流速 y',
    Uz: '流速 z',
    p: '圧力',
    p_rgh: '修正圧力',
    T: '温度',
    h: 'エンタルピー',
    k: '乱流運動エネルギー',
    epsilon: '散逸率',
    omega: '比散逸率',
    nut: '乱流粘性',
    nuTilda: '修正乱流粘性',
    alphat: '乱流熱拡散率',
    nut_over_nu: '粘性比',
    rho: '密度',
    phi: '流束',
    wallShearStress: '壁面せん断応力',
    vorticity: '渦度',
  },
  fieldTooltips: {
    von_mises:
      '相当引張応力。延性材料の降伏判定が比較する量です。構成上、符号を持ちません。純圧縮の部品は同じ大きさの純引張と同じ値を示し、純せん断状態では √3 倍高く読まれます。荷重の向きが重要な場合は主応力を併せて確認してください。',
    max_principal:
      '最大主応力 σ1。符号付きで、正が引張です。ピークが亀裂を開こうとしているのか閉じようとしているのかを示し、脆性材料の判定基準となります。',
    min_principal:
      '最小主応力 σ3。符号付きで、最も負の点が部品内で最も圧縮されている箇所です。σ1 と並べて読むことで、面圧による接触か引張のホットスポットかを区別できます。',
    max_shear:
      '任意面での最大せん断応力、トレスカの (σ1 − σ3) / 2。伸びるのではなく滑るボルト接合や接着接合を支配する量であり、仕様が von Mises ではなくトレスカ基準を求める場合の基礎です。',
    // Mass & inertia (FEA). The frame is repeated on every tensor
    // component deliberately — the backend does not emit the centre of
    // mass, so this is the only place it is stated.
    mass: '総質量 — 各ソリッドボディのCAD体積に割り当てられた材料の密度を掛けた総和。抽出された流体キャビティは除外されます。',
    inertiaIxx:
      'x軸まわりの慣性モーメント（組立体の重心まわり、グローバルメッシュ座標系）。',
    inertiaIyy:
      'y軸まわりの慣性モーメント（組立体の重心まわり、グローバルメッシュ座標系）。',
    inertiaIzz:
      'z軸まわりの慣性モーメント（組立体の重心まわり、グローバルメッシュ座標系）。',
    inertiaIxy:
      'xy慣性乗積（組立体の重心まわり、グローバルメッシュ座標系）。ゼロでない場合、グローバル軸は主軸ではありません。',
    inertiaIxz: 'xz慣性乗積（組立体の重心まわり、グローバルメッシュ座標系）。',
    inertiaIyz: 'yz慣性乗積（組立体の重心まわり、グローバルメッシュ座標系）。',
    radiusOfGyrationX:
      'x軸まわりの回転半径 — √(Ixx/m)。主軸ではなくグローバル軸まわりです。',
    radiusOfGyrationY:
      'y軸まわりの回転半径 — √(Iyy/m)。主軸ではなくグローバル軸まわりです。',
    radiusOfGyrationZ:
      'z軸まわりの回転半径 — √(Izz/m)。主軸ではなくグローバル軸まわりです。',
    p_rgh:
      '修正圧力 p − ρgh (静水頭を差し引いた圧力) — CHT ソルバーが解く量. 運動学的 (p/ρ, m²/s²); 単位を切り替えれば ρ を通して絶対値 Pa/psi として読める. 残差は連続 / 質量保存の収束性を示す.',
    p: '静圧 — 非圧縮 OpenFOAM は運動学的表現で解く (p/ρ, m²/s²); 単位を切り替えれば ρ を通して絶対値 Pa/psi として読める. 残差は連続 / 質量保存の収束性を示す.',
    U: '速度ベクトル — 運動量方程式の残差 (3 成分の大きさ).',
    Ux: '速度の x 成分 — 運動量方程式の残差.',
    Uy: '速度の y 成分 — 運動量方程式の残差.',
    Uz: '速度の z 成分 — 運動量方程式の残差.',
    h: 'エンタルピー — エネルギー方程式の残差 (CHT の固体・流体温度カップリング).',
    k: '乱流エネルギー — k-ε / k-ω モデルの残差.',
    omega: '比消散率 ω — k-ω / SST モデルの残差 (渦粘性スケール).',
    epsilon: '乱流散逸率 ε — k-ε モデルの残差.',
    nut: '乱流渦粘性 νₜ — 導出場; 残差はクロージャーの安定性を示す.',
    alphat:
      '乱流熱拡散率 αₜ — 導出場; 乱流をエネルギー方程式にカップリングする.',
    temperature:
      '共役熱伝達解析の定常温度場 — 流体・固体領域で同一スケールを共有.',
    pressure_drop_pa: '領域全体の静圧損失 (入口 − 出口), 絶対値 Pa.',
    pumping_power_w:
      '冷却液を流すための理想的な水力動力: 圧力損失 × 体積流量 (Δp × ṁ/ρ)。ポンプ効率やモーター損失は含まない。',
    pressure_drop_kinematic:
      '同じ圧力損失を運動学的表現 (Δp/ρ, m²/s²) で示したもの — 絶対値 Pa を流体密度 ρ で割った値.',
    tempStat:
      '当該領域における定常温度の極値 — 収束時の温度場の最小 / 平均 / 最大.',
    velMax: '収束時における当該領域内の最大速度大きさ.',
    force_normal_mag:
      '物体壁面にかかる圧力 (法線) 力の総和の大きさ. 流れ軸に依存しない — Cx/Cy/Cz 成分を選ばずに直接的な壁面荷重の指標として使える.',
    force_tangential_mag:
      '物体壁面にかかる粘性 (接線) 力の総和の大きさ — 表面摩擦成分. 流れ軸に依存しない.',
    normal_tangential_ratio:
      '法線 (圧力) ÷ 接線 (粘性) 壁面力. 高い = 圧力支配の荷重; 低い = 摩擦支配. 無次元; 接線力が 0 のときは null.',
    wall_pressure_min_pa:
      '物体壁面上のゲージ圧の最小値, 絶対値 Pa. 構造設計における壁面荷重入力として利用できる.',
    wall_pressure_max_pa:
      '物体壁面上のゲージ圧の最大値, 絶対値 Pa. 構造設計におけるピーク壁面荷重入力として利用できる.',
    force_pressure_x:
      '物体壁面上の圧力 (法線) 力の X 成分. すべての壁面にわたる p·n の総和.',
    force_pressure_y: '物体壁面上の圧力 (法線) 力の Y 成分.',
    force_pressure_z: '物体壁面上の圧力 (法線) 力の Z 成分.',
    force_viscous_x: '物体壁面上の粘性 (接線) 力の X 成分 — 表面摩擦寄与.',
    force_viscous_y: '物体壁面上の粘性 (接線) 力の Y 成分.',
    force_viscous_z: '物体壁面上の粘性 (接線) 力の Z 成分.',
    inlet_flow_rate_m3s:
      '収束時の入口面を通る体積流量. 符号：ドメインへ流入するとき正. 出口と Mass Imbalance Frac の範囲内で一致すべき.',
    outlet_flow_rate_m3s:
      '収束時の出口面を通る体積流量. 符号：ドメインから流出するとき正.',
    outlet_velocity_avg_ms: '収束時の出口面上の面積加重平均速度の大きさ.',
    inlet_velocity_avg_ms:
      '収束時の入口面上の面積加重平均速度の大きさ — スタディの入口速度 BC と一致すべき.',
    mass_imbalance_frac:
      '|inlet − outlet| / max(|inlet|, |outlet|) — 収束時の質量保存の分数誤差. 通常 1e-4 未満; 1e-2 超は連続の式が完全に閉じていないことを示す.',
    time_step_count:
      '残差目標か最大反復上限のどちらかに達するまでにソルバーが実行した反復 (または過渡の場合はタイムステップ) の総数.',
    last_time_step:
      'ソルバーが書き出した最終反復カウンタの値. 通常実行では総ステップ数と一致; ソルバーが中断された場合は異なる可能性あり.',
    execution_time_s:
      'ソルバーが反復に費やした実時間, 秒. ケース設定, メッシュ変換, 結果抽出は含まない.',
    solution_unphysical:
      'ソルバーが収束場で非物理的な値を検出した場合 true — 負の体積, 非有限残差, 不適切な BC.',
    divergence_detected:
      '残差が反復にわたって減少ではなく増加した場合 true — ソルバーは収束せず, 結果は信頼できない.',
    cd: '抗力係数 (C_D) — 流れ方向の圧力 + 粘性力を ½·ρ·U²·A_ref で正規化. 無次元.',
    cl: '揚力係数 (C_L) — 流れに直交する圧力 + 粘性力を ½·ρ·U²·A_ref で正規化. 無次元.',
    cm_pitch:
      'ピッチングモーメント係数 (C_M) — 設定したピッチ軸 (流れ軸に直交) まわりのモーメントを ½·ρ·U²·A_ref·l_ref で正規化. 符号は右手則に従う: 正の C_M = +ピッチ軸方向から見て反時計まわり, 負 = 時計まわり. これが機首上げ / 下げのどちらに対応するかは, XYZ のどの軸をピッチ軸に選び, ドメイン内で物体がどう向いているかで決まる. 無次元.',
    cl_cd_ratio: '揚抗比 — C_L / C_D. 空力効率の指標. 無次元.',
    cop_frac_lref:
      '圧力中心 (CoP) — 基準弦方向にわたる圧力分布が一点の集中力として作用する位置. モーメント基準点からピッチ軸方向 (流れ・揚力軸に垂直) に測った距離を, 基準弦 (l_ref) の割合として表す. 0 = モーメント基準点, 0.25 = 1/4 弦位置 (薄翼理論の空力中心), 1.0 = 一弦分下流. 無次元. 空力の力 / モーメントが 0 の場合 null.',
    cd_band:
      '最終反復ウィンドウでの C_D 変動の半幅 — 実行終了時に抗力がどれだけ揺れていたかを示す. ゼロに近い = 値が収束; 大きい = C_D を信頼する前に反復回数を増やすこと.',
    cl_band:
      '最終反復ウィンドウでの C_L 変動の半幅 — 実行終了時に揚力がどれだけ揺れていたかを示す. ゼロに近い = 値が収束; 大きい = C_L を信頼する前に反復回数を増やすこと.',
    temperature_min: '領域全体で見た定常状態の流体温度の最小値 (K).',
    temperature_avg: '収束時の体積重み付け平均流体温度 (K).',
    temperature_max: '領域全体で見た定常状態の流体温度の最大値 (K).',
    yplus_min:
      '収束時における物体壁面上での y⁺ の最小値. 5 未満は粘性底層を解像 (低 Re モデルが必要); 壁関数を使う場合の 30 未満は解像不足.',
    yplus_mean:
      '収束時における物体壁面上での面積加重平均 y⁺. 壁近傍メッシュ寸法の妥当性を一目で確認する代表値.',
    yplus_max:
      '収束時における物体壁面上での y⁺ の最大値. 壁関数使用時に 300 を超えると対数則が有効範囲外となり, せん断応力・熱伝達がずれる.',
    yplus_frac_below_5:
      '収束時に y⁺ < 5 となる濡れ壁面積の割合 — 粘性底層帯. 壁関数を使う場合にこの帯が高いと近壁メッシュがモデルに対して過解像; 低 Re / 壁解像モデルではこの帯が支配的であることが望ましい.',
    yplus_frac_5_to_30:
      '収束時に 5 ≤ y⁺ < 30 となる濡れ壁面積の割合 — 遷移層で, 壁関数にも低 Re 解像 BL にも有効ではない領域. ここに実質的な面積があると, せん断応力と熱伝達がモデルの空白領域で評価されている; 近壁メッシュを細分化または粗くしてこの帯から外す.',
    yplus_frac_30_to_100:
      '収束時に 30 ≤ y⁺ ≤ 100 となる濡れ壁面積の割合 — 標準的な対数則壁関数のスイートスポット. 壁関数運転では高いほど近壁メッシュ寸法が健全.',
    yplus_frac_above_100:
      '収束時に y⁺ > 100 となる濡れ壁面積の割合 — 対数則の有効範囲を超えた領域. 壁関数運転でここに実質的な面積があると, せん断応力・熱伝達がモデル範囲外で評価されており, 下流の抗力・揚力・熱流束は信頼できない.',
    solver_failed:
      'ソルバーが非ゼロ終了したか強制終了された場合に真。失敗バナーと同じ内容を、再試行ロジックが分岐できる形で持ちます。',
    velocity_runaway:
      '実行停止までに速度の大きさが発散した場合に真。本当に発散した運動量計算と、単に反復回数が尽きた計算とを区別します。',
    singular_matrix_detected:
      'OpenFOAM が特異行列を報告した場合に真。閉じた領域では、圧力の基準点が設定されておらず圧力場の絶対値が定まらないことをほぼ意味します。',
    hint_bc_ic:
      '失敗のパターンが境界条件・初期条件を示している場合に設定されます（圧力行列の特異、連続の式の異常終了、10 反復未満での停止）。',
    hint_mesh_quality:
      'いずれか 1 ステップで圧力ソルバーが 50 回以上の反復を要した場合に設定されます（1 ステップでも該当すれば設定）。非直交性やアスペクト比が大きい、条件の悪いセルを示します。',
    hint_turbulence:
      '圧力や速度より先に乱流場（k・ω・ε）が NaN になった場合に設定され、運動量計算ではなく乱流モデル側を示します。これらの場を解かない層流では設定されません。',
    exit_code:
      'ソルバープロセスの終了ステータス。コンテナが強制終了された場合（タイムアウトやメモリ不足）は存在しません。',
    max_p_linear_iters:
      '単一ステップで圧力線形ソルバーが要した最大反復数。継続的に大きい値がメッシュ品質のヒントの根拠になります。',
    divergence_onset_step:
      '残差が減少から増加に転じた最初のステップ。発散が検出されなかった場合は null。',
    first_diverged_field:
      '最初に残差が増加した場。最初に崩れた場が修正すべき対象であることが多く、乱流場と圧力場とでは原因が異なります。',
    cumulative_continuity:
      '反復にわたる累積質量保存誤差. 圧力残差と共に減衰すべき; プラトーや増加は連続性が閉じきっていないことを示す (BC の不整合, メッシュ非直交性, 圧力ソルバーの緩和不足など).',
    solver_mpi_ranks:
      'ソルバーが領域を分割した MPI ワーカーランク数. 並列トポロジのみで物理には影響しない; 失敗したランで分割が原因の可能性を切り分ける際に有用.',
    sim_error_yplus_min:
      '判定された計算の壁面 y+ の最小値で、参考として表示しています。1 つの面 (角部やよどみ点であることが多い) の値であり、これだけでフラグは決まりません。y+ 下限側の判定は壁面面積の割合と乱流モデルで行います。どのモデルでも壁面の 10% 超が y+ 5〜30 のバッファ層にあればフラグが立ち、y+ 5 未満が 10% を超える場合は対数則型の壁関数を使う k-ε のときだけフラグが立ちます。y+ ≈ 1 にメッシュ分割した k-ω SST は粘性底層を解像した壁であり、問題ではありません。この判定より前の計算は、この単一の値だけでフラグが立っていました。',
    // ---- CHT 結果行のツールチップ ----
    chip_t_max_k:
      '発熱源としてフラグされた全ての固体領域における最高温度。ターゲット温度に対する合否バッジを決定します。',
    target_temperature_k:
      'ユーザー設定の温度上限。null の場合、ハードコードされた 70 °C 制限が電子機器以外のケースを誤って合格させないため、合否判定は表示されません。',
    target_met:
      'chip_t_max_k が target_temperature_k を下回ったかどうか。ターゲット未設定時は null。',
    coolant_mass_flow_kg_s:
      '収束時における流体領域の冷媒質量流量。新しいソルバー実行で出力され、旧実行では空欄となります。',
    coolant_delta_t_k:
      '流体領域を通過する冷媒のエンタルピー上昇 (出口温度 − 入口温度)。ṁ · c_p と組み合わせると、実際に冷媒が除去した熱流量が得られます。',
    coolant_mass_imbalance_kg_s:
      'ソルバー報告の冷媒入口と出口の質量不均衡。収束実行では ~0 であるべき; 非ゼロは質量バランスが丸め誤差内で閉じなかったことを示します。',
    total_heat_flux_w:
      'このランで冷媒 ↔ 固体のすべての界面を通過するワット数の合計。各パッチは 1 組の冷媒 ↔ 固体 (coolant ↔ solid_0, coolant ↔ solid_1, …) を表し, ここの数値はその総和です。保存値は固体へ流入する熱を正とするため, 固体が冷媒を加熱する通常の冷却方向では負になります。冷媒が受け取る熱はこの値の符号を反転したものです。パッチ別の内訳はランが記録した場合に領域グラフで確認できます; 整合性チェックパネルで宣言熱流量と比較します。',
    peak_heat_flux_w_m2:
      '流体 ↔ 固体界面上のあらゆる場所における最大局所熱流束。高い値はメッシュ細分化が必要なホットスポットを示します。ピークが属するパッチ名はランが記録した場合に領域グラフで表示されます。',
    interfacePerPatch:
      '1 つの界面パッチを横切るワット数 (保存値)。正 = パッチの固体側へ流入する熱 (固体 ↔ 固体パッチでは最初に名前のある領域へ)。固体が冷媒に熱を渡す通常の冷却方向では負になり, 冷媒パッチの正の値は冷媒がその固体を加熱していることを意味します。',
    t_min_k: '収束時における領域内の最低温度。',
    t_avg_k: '収束時における領域内の体積平均温度。',
    t_max_k: '収束時における領域内の最高温度。',
    u_max_m_s: '収束時における領域内の最大速度の大きさ。',
    iterations_run:
      'ソルバーが実行した SIMPLE 反復回数。反復予算に達しても収束していない場合、この実行は定常解ではなくスナップショットとして扱うべきです。',
    converged: '残差が反復予算内で設定許容値を下回ったかどうか。',
    velocity_cells:
      '最終反復で速度リミッターがクランプしたセル数。非ゼロは、ソルバーが実行を維持するために U を積極的に抑制していたことを意味 — 下流量はクランプされた領域がメッシュされるか、より適切に駆動されるまで示唆的とみなすべきです。',
    velocity_cells_pct:
      '最終反復で速度リミッターがクランプした流体メッシュの割合。> 0.1 % はソルバーが制約せざるを得なかったフィールド上で実行が収束したことを意味します。',
    temperature_lower_cells:
      '温度下限リミッターがクランプしたセル数。非ゼロは、どこかで T が安全下限を下回り、引き上げが必要だったことを意味します。',
    temperature_upper_cells:
      '温度上限リミッターがクランプしたセル数。非ゼロは、どこかで T が安全上限を超え、抑制が必要だったことを意味します。',
    temperature_lower_cells_pct: '温度下限リミッターがクランプしたセルの割合。',
    temperature_upper_cells_pct: '温度上限リミッターがクランプしたセルの割合。',
    temperature_unlimited_max_k:
      'クランプ発動前にソルバーが観測した最高温度。この値とクランプ上限との差が大きいほど、ソルバーがフィールドを抑制するために手を伸ばした距離が長かったことを意味します。',
    temperature_unlimited_min_k: 'クランプ発動前にソルバーが観測した最低温度。',
    limit_temperature_max:
      '温度リミッターが設定された上限。この値を上回ったセルは各反復でリセットされました。',
    n_increments:
      '周期に到達するまでに CalculiX が進めた物理時間増分の数。各増分は熱伝達ステップ内の 1 回の Δt 前進です。',
    n_frames:
      '結果タイムライン用に書き出された温度フレーム数。出力間隔で決まり、周期を割り切れるときはおおむね サイクル期間 ÷ 間隔 + 1 です。',
    time_reached:
      'ソルバーが実際に到達した物理時間。完了した実行では周期と一致し、途中停止では短くなります。',
    time_reached_s:
      'ソルバーが実際に到達した物理時間。完了した実行では周期と一致し、途中停止では短くなります。',
    surface_fluxes_w:
      '固体側の面熱流束 (W)、実行に保存された符号: 負は固体を加熱、正は冷却。熱収支カードはこの符号を反転し、赤チップを加熱として見せます。',
    peak_temperature_K:
      '期間全体で固体のどこかに現れた最高温度 — 最終フレームだけではありません。ピーク時刻とピーク部位がいつ・どこかを示します。',
    energy_in_j:
      '期間中に固体へ入った熱エネルギー (∫Q_in·dt)。増分ごとの境界面熱流を積分したものです。',
    energy_out_j:
      '期間中に固体から出た熱エネルギー (∫Q_out·dt)。増分ごとの境界面熱流を積分したものです。',
    stored_energy_change_j:
      '期間中の固体蓄熱エネルギーの変化 (ρ·c_p·∫V ΔT)。∫Q_in と ∫Q_out と合わせてエネルギー帳を閉じます — 最終ステップの面積分メッシュ分解能チェックとは別の問いです。',
    energy_imbalance_j:
      'エネルギー帳の残差: ∫Q_in − ∫Q_out − ΔE_stored。大きい値は期間帳が閉じなかったことを意味します（復元勾配に残る面はメッシュ分解能で帳を広げ得ます）。',
  },
  cht: {
    // ENG-1912 — 手算アンカー + 6軸レーダー用の宣言値。ソルバーには渡らない。
    // ゼロ以下を入力したときの表示。`SimGeometry` は両方の項目を gt=0 と
    // 宣言しているため、そのまま送信すると原因の項目が分からない 422 になる。
    mustBePositive: '0 より大きい値を入力してください。',
    handCalcGeometry: '手算用ジオメトリ',
    // 記号と単位は JSX 側で normal-case 付きで合成（RowLabel だと D_h (m) → D_H (M)）。
    hydraulicDiameter: '水力直径',
    hydraulicDiameterInfo:
      '冷却流路の水力直径 (濡れ断面の 4·A/P)。レポートの手算パネルの D_h 欄を初期化し、Nu と j 係数のレーダー軸を確定させます。ソルバー入力ではないため、空欄でも解析結果は変わりません。',
    characteristicLength: '特性長さ',
    characteristicLengthInfo:
      '固体内を熱が伝わる距離。通常は壁または底板の厚み。レポートの手算パネルの L 欄を初期化し、Bi のレーダー軸を確定させます。ソルバー入力ではありません。',
    fluid: '流体',
    fluidMaterials: {
      water_20c: '水 (20 °C)',
      egw_50_50_25c: 'EGW 50/50 (25 °C)',
      pg_25_25c: 'PG 25 (25 °C)',
      air_20c: '空気 (20 °C)',
    },
    fluidMaterialsFull: {
      egw_50_50_25c: 'Ethylene glycol–water 50/50 mix',
      pg_25_25c: 'Propylene glycol–water 25% mix',
    },
    syncAria: '流体特性を流入温度に同期',
    syncUnsupported:
      '{{material}} の温度補間特性は近日対応予定です。現在、温度テーブルがあるのは水のみです。',
    syncNeedsInletTemp:
      'まず流入温度を設定してください — 同期はこれを用いて動作点での水の特性を参照します。',
    syncCompute:
      '現在の流入温度（{{kelvin}} K / {{celsius}} °C）における水の密度・粘度・Cp・k を計算し、オーバーライドとして書き込みます。有効範囲 0〜100 °C。範囲外では端点値にクランプされます。',
    density: '密度',
    densityInfo:
      '単位体積あたりの質量。値を入力してプリセットの既定値を上書きします。',
    kinematicViscosity: '動粘度',
    kinematicViscosityInfo:
      '動粘度（ν = μ/ρ）。1.5e-5 のような指数表記を受け付けます。',
    specificHeat: '比熱',
    specificHeatInfo:
      '定圧比熱。流体 1 kg を 1 K 上昇させるのに必要なエネルギー。',
    thermalConductivity: '熱伝導率',
    thermalConductivityInfo:
      '流体が熱を伝える能力。下のプラントル数は、この値と上の 3 つの値から求められます。',
    prandtlTabulated:
      '未使用 — 物性値が表形式のため、ケースファイルは k を直接持ち、Pr の項目はありません。',
    prandtlDerived: 'ρ, ν, Cp, k から算出',
    prandtlPinned:
      'このケースで固定値。上の k はこれから算出されるため、ρ・ν・Cp を変えると k も動きます。熱伝導率を入力すると上書きされます。',
    inlet: '流入',
    velocity: '速度',
    velocityInfo: '流れ軸に沿った流入速度の大きさ。',
    inletTemperature: '流入温度',
    inletTemperatureInfo: '領域に流入する流体の温度。',
    solidRegion: '固体領域',
    material: '材料',
    materialInfo:
      '固体材料を選択してください — 下の密度・熱伝導率・比熱は材料ライブラリから取得されます。',
    selectMaterial: '材料を選択…',
    heatSource: '発熱源',
    heatSourceInfo:
      'このボディがどのように発熱するか。総熱流量はデータシートに記載される値、出力密度は 1 立方メートルあたりのワット数です。「熱伝導のみ」はこのボディが発熱しないことを明示するもので、未指定とは異なります。',
    heatSourceKind: {
      undeclared: '未指定',
      none: '熱伝導のみ（発熱なし）',
      totalPower: '総熱流量（W）',
      powerDensity: '出力密度（W/m³）',
    },
    totalPower: '総熱流量',
    totalPowerNote:
      '解析時にこの領域のメッシュ体積で除算されるため、メッシュとの不整合が生じません。',
    volumetricHeatSource: '体積発熱源',
    volumetricHeatSourceNote: '領域全体にわたる均一な出力密度。',
    egValue: '例：{{value}}',
    solidRegions: '固体領域',
    noSolidRegionsTitle: '固体領域が検出されません',
    noSolidRegionsBodyPre:
      'CHT には少なくとも 1 つの固体領域が必要です。Mesh ステップで CAD ボディを分類してください — ボディの役割は次に流れ込みます：',
    noSolidRegionsBodyPost: '、ここで領域リストを初期化します。',
    solidFaceBcs: '固体面の境界条件',
    loadingMeshPatches: 'メッシュパッチを読み込み中…',
    noSolidFacesTitle: '固体側の面がまだタグ付けされていません',
    noSolidFacesBody:
      'Mesh ステップ（境界割り当て）で固体表面をタグ付けすると、ここで面ごとの熱境界条件を割り当てられます。流体の流入 / 流出面はこのリストには表示されません — 上部で制御します。流体↔固体の界面パッチはソルバーが自動で接続します。',
    facesCount: '{{count}} 面',
    faceBcKindInfo:
      'Adiabatic = 完全断熱面（熱流束なし）。Fixed Temperature = 表面を目標温度 T に保持。Convection = 対流係数 h を介した周囲との熱交換。',
    bcKind: {
      adiabatic: '断熱',
      fixedTemperature: '固定温度',
      convection: '対流',
    },
    temperature: '温度',
    temperatureInfo: 'この値に固定される表面温度。',
    convectionCoefficient: '対流係数',
    convectionCoefficientInfo:
      '熱伝達係数 h。自然対流の空気 ~5、強制対流の空気 ~50、水 ~1000+、沸騰 ~10k+。',
    ambientTemperature: '周囲温度',
    ambientTemperatureInfo: '表面から離れた自由流の温度。',
    adiabaticNote: 'この面には熱流束がありません — 完全断熱。',
    flowType: '流れの種類',
    flowTypeInfo:
      '乱流モデル。k-ω SST は境界層を解像します（y+ ≲ 5 のメッシュが必要）。k-ε / k-ω は壁関数を使用します（y+ 30〜300）。laminar は低レイノルズ数の流れ向け（Re ≲ 2000）。',
    flowTypeLaminar: '層流',
    flowTypeKEpsilon: 'k-ε（標準）',
    flowTypeKOmega: 'k-ω',
    flowTypeKOmegaSst: 'k-ω SST',
    turbulence: '乱流',
    intensity: '強度',
    intensityTooltip:
      '速度変動と平均流れの比（u′/U）。初期乱流運動エネルギー k を設定します。典型値：外部流 0.01〜0.05、内部流 0.05〜0.10。',
    lengthScale: '長さスケール（m）',
    lengthScaleTooltip:
      '初期 ω と ε を設定するための特徴渦サイズ。目安：ジオメトリの特徴長さ（コード長、直径、スパン）の約 7〜10%。既定値は 0.1 m。',
    convergenceCriteria: '収束条件',
    maxIterations: '最大反復数',
    maxIterationsInfo:
      '最大ソルバー反復数。空欄の場合は乱流モデルの既定値を使用します（層流：1500、RAS：2000）。',
    residualFluid: '残差 {{key}}',
    residualFluidInfo:
      '{{key}} の収束目標。低いほど厳格。典型値 1e-4 〜 1e-6。',
    residualSolid: '残差 {{key}}（固体）',
    residualSolidInfo:
      '固体領域のエンタルピー（固体エネルギー方程式が実際に解く場）の収束目標。熱伝導は流体場より厳しく収束する傾向があります。',
    solverSettings: 'ソルバー設定',
    moreOverridesTitle: 'スキーム・壁関数・出力',
    writeInterval: '書き込み間隔',
    writeIntervalInfo:
      '解場スナップショットの反復間隔。小さいほどフレーム数が増え、ディスク使用量も増えます。',
    relaxU: '緩和 U',
    relaxUInfo: '速度の低緩和係数。低いほど安定するが収束は遅くなります。',
    relaxP: '緩和 P',
    relaxPInfo:
      '圧力の低緩和係数。空欄の場合は乱流モデルの既定値を使用します（層流：0.3、RAS：0.2）。',
    relaxH: '流体のエネルギー緩和係数',
    limitVelocityFactor: '速度制限係数',
    limitVelocityFactorInfo:
      '入口速度の倍数として与える速度上限（limitVelocity fvOption）。1 セルの局所的なスパイクが、全体としては健全な解を壊すべきではありません。0 で制限を無効化します。',
    limitTemperatureMin: '温度制限（下限）',
    limitTemperatureMinInfo:
      '流体温度の下限（limitTemperature fvOption）。内部ではケルビンで保持し、単位メニューで °C / °F を選べます。空欄にすると制限をオフにするのではなく、入口温度を基準とした範囲を導出します。片側だけを上書きすると導出側と逆転し得るため、下限と上限はセットで指定してください。',
    limitTemperatureMax: '温度制限（上限）',
    limitTemperatureMaxInfo:
      '流体温度の上限（limitTemperature fvOption）。内部ではケルビンで保持し、単位メニューで °C / °F を選べます。空欄にすると制限をオフにするのではなく、入口温度を基準とした範囲を導出します。片側だけを上書きすると導出側と逆転し得るため、下限と上限はセットで指定してください。',
    nonOrthCorrectorsFluid: '非直交補正（流体）',
    nonOrthCorrectorsFluidInfo:
      '流体領域における 1 反復あたりの追加圧力補正回数。歪んだセルを補償します。流体側は境界層を含むため、固体側とは別に指定します。既定値: 3。',
    nonOrthCorrectorsSolid: '非直交補正（固体）',
    nonOrthCorrectorsSolidInfo:
      '各固体領域における 1 反復あたりの追加の非直交補正回数。四面体メッシュでは熱伝導項そのものに補正が必要で、補正がないと薄い固体層が熱を伝えすぎます。既定値: 2。',
    laplacianLimiterSolid: 'ラプラシアンリミッター（固体）',
    laplacianLimiterSolidInfo:
      '固体の熱伝導項に非直交補正をどれだけ残すか。1 は完全な補正です。流体側の 0.33 では薄い四面体層が約 14% 熱を伝えすぎました。既定値: 1。',
    relaxHInfo:
      '流体のエネルギー更新幅を調整します。既定値は 0.5 です。固体の欄が空の場合もこの値を使います。',
    advanced: '詳細設定',
    relaxHSolid: '固体のエネルギー緩和係数',
    relaxHSolidInfo:
      'すべての固体のエネルギー更新幅を調整します。空欄の場合は流体の値を使います。値が小さいほど更新幅が小さくなります。',
    validation: {
      inletVelocityRequired: '流体の流入速度は必須です。',
      inletTemperatureRequired: '流体の流入温度は必須です。',
      openingNeedsInlet:
        '冷却材が入る開口を指定してください。開口が 3 つ以上あるため、メッシャーは向きを推測せず番号を振っています — 入口が 1 つも無いと流れを駆動するものがありません。',
      openingNeedsOutlet:
        '冷却材が出る開口を指定してください。出口が無いと冷却材の行き先が無く、計算の準備ができません。',
      openingsUnassigned_one:
        '開口 {{patches}} は向きが未設定のため封止されます。冷却材を通す場合は指定してください。',
      openingsUnassigned_other:
        '開口 {{patches}} は向きが未設定のため封止されます。冷却材を通す場合は指定してください。',
      inletTemperatureImplausible:
        '流入温度 {{kelvin}} K は妥当ではありません — 値は絶対温度（ケルビン）です（室温は 293.15 K）。°C を入力して換算し忘れていませんか？',
      noFluidRegion: 'CHT には流体領域がちょうど 1 つ必要です — 未設定です。',
      tooManyFluidRegions:
        'CHT で許可される流体領域は 1 つのみです。現在 {{count}} 個設定されています。',
      noSolidRegion:
        'CHT には少なくとも 1 つの固体領域が必要です — 未設定です。',
      unknownFluidMaterial:
        "領域 '{{region}}' の流体材料 '{{material}}' が不明です。",
      fluidPropsStale:
        '流体特性は 20 °C にアンカーされていますが、流入温度は {{celsius}} °C です — 同期ボタン（↻）をクリックして、動作点での密度・ν・Cp・k を再計算してください。',
      inletTempOutsideWaterRange:
        '流入温度 {{celsius}} °C は検証済みの水特性範囲（0〜100 °C）を超えています。値は端点でクランプされます。',
      unknownSolidMaterial:
        "領域 '{{region}}' の固体材料 '{{material}}' が不明です。",
      noSpecificHeat:
        "固体領域 '{{region}}'：材料 '{{material}}' には比熱がありません。",
      heatSourceNonPositive:
        "固体領域 '{{region}}'：発熱源は 0 {{unit}} より大きくなければなりません（現在 {{value}}）。このボディが発熱しない場合は「熱伝導のみ」を選択してください。",
      heatSourceOutOfRange:
        "固体領域 '{{region}}'：発熱源 {{value}} {{unit}} は典型的な工学的範囲（{{lo}}〜{{hi}} {{unit}}）を超えています — 単位を確認してください。",
      regionKeyMismatch:
        "領域キー '{{key}}' はどのメッシュボディラベルにも一致しません — ソルバーは constant/{{key}}/polyMesh を見つけられず、流体↔固体の結合が空になります。メッシュに一致するよう領域名を変更してください。",
      noHeatSource:
        '発熱源が定義されていません — シミュレーションは等温になります。固体領域に発熱源を設定するか、固体面に固定温度 / 表面熱流束 / 対流の境界条件を設定してください。',
      staleFaceBc:
        "境界条件が参照する面 '{{faceId}}' は選択したメッシュに存在しません — 求解時に無音で断熱になります。古い境界条件を削除するか、このパッチを持つメッシュを選択してください。",
    },
  },
} as const;
